/**
 * @fileoverview jQuery
 * @link https://jquery.com/
 */

import jQuery from 'jquery'

window.$ = window.jQuery = jQuery
